import configuraMenu from "./footage/menu";
import { creaMasonry } from "./masonry";
import listaDesplegable from "./footage/lista_desplegable";
import bloques from "./footage/bloques";
import menu from "./lib/menu";
import '../sass/app.scss';
import '../sass/producto.scss';
import '../sass/issue.scss';
import '../sass/review.scss';
import '../sass/article.scss';
import '../sass/entrada.scss';
import videos from "./footage/videos";
var configuraActualizacionDeAltura = function () {
    var ultimoScroll = -1, ultimoAltoCabecera = -1;
    var cabeceraPrincipal = document.querySelector('.cabeceraPrincipal'), actualizaCabecera = function () {
        if (ultimoScroll !== scrollY) {
            document.documentElement.style.setProperty('--scroll', "".concat(scrollY));
            ultimoScroll = scrollY;
        }
        if (ultimoAltoCabecera !== cabeceraPrincipal.offsetHeight) {
            var altura = cabeceraPrincipal.getBoundingClientRect().bottom;
            document.documentElement.style.setProperty('--alto-cabecera', "".concat(altura, "px"));
            ultimoAltoCabecera = altura;
        }
        requestAnimationFrame(actualizaCabecera);
    };
    actualizaCabecera();
};
if (document.querySelector('.masonry-elementos')) {
    var masonry = creaMasonry('.masonry-elementos');
    masonry.inicializa();
}
listaDesplegable();
configuraMenu();
bloques();
configuraActualizacionDeAltura();
videos();
menu();
var cart = document.querySelector('.menu-item.cart .qty');
if ("jQuery" in window && cart) {
    jQuery(document)
        .on('updated_cart_totals', function () {
        var inputs = [].slice.call(document.querySelectorAll('.input-text.qty')), reducer = function (acc, input) { return acc + parseInt(input.value, 10); }, total = inputs.reduce(reducer, 0);
        console.log(total);
        cart.innerHTML = total.toString();
    })
        .on('wc_cart_emptied', function () { return cart.innerHTML = '0'; });
}
